import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { CallHistoryMethodAction, push } from 'connected-react-router';

import AppState from '@webapp/store/state';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import BackIcon from '@components/basics/icons/back';
import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';
import FormContainer from '@components/layout/form-container';
import CircleCheckIcon from '@components/basics/icons/circle-check';

interface DowngradeSuccessPageProps {
  className?: string;
  selectedPlan: string;
  goToSubscriptions: () => CallHistoryMethodAction;
}

const mapStateToProps = (state: AppState, props: any) => {
  const { clientId, id } = props.match?.params;

  const foundSubscription = state.subscriptionManager.summary?.artists
    .find((s) => s.id === clientId)
    ?.subscriptions.find((s) => s.id === id);

  const foundLabelSubscription = state.subscriptionManager.summary?.recordLabels
    .find((s) => s.id === clientId)
    ?.subscriptions.find((s) => s.id === id);

  return {
    selectedPlan: foundSubscription?.plan || foundLabelSubscription?.plan || '',
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goToSubscriptions: () => dispatch(push('/artist/subscriptions')),
});

export const DowngradeSuccessPage = ({
  ...props
}: DowngradeSuccessPageProps) => {

  return (
    <MotionOpacity className={`${props.className || ''} mt-80`}>
      <FormContainer>
        <Flex className="mb-50" justifyContent="flex-start" alignItems="center">
          <StyledBackIcon onClick={() => props.goToSubscriptions()} />
          <Typography uppercase weight="700">
            <Translate id="ONBOARDING.DOWNGRADE.SUCCESS.BTN" />
          </Typography>
        </Flex>
        <Content>
          <CircleCheckIcon className="mb-40" iconSize={64} />
          <Typography
            className="mb-20"
            align="center"
            type="subheader"
            weight="400"
          >
            <Translate id="ONBOARDING.DOWNGRADE.SUCCESS.TEXT" />{' '}
            {props.selectedPlan} Plan
          </Typography>
          {/* <Typography align="center" type="title" weight="400" opacity=".5">
            {props.selectedPlan} <Translate id="ONBOARDING.DOWNGRADE.EXPIRE" />
          </Typography> */}
        </Content>
      </FormContainer>
    </MotionOpacity>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(DowngradeSuccessPage)`
  margin-top: 40px;
  padding-bottom: 200px;

  @media ${({ theme }) => theme.device.tablet} {
    margin-top: 80px;
  }
`);

const StyledBackIcon = styled(BackIcon)`
  margin-right: 20px;
`;

const Content = styled(Flex).attrs(() => ({
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}))`
  margin-top: 40px;
  @media ${({ theme }) => theme.device.tablet} {
    margin-top: 160px;
  }
`;
